export default __webpack_public_path__ + "static/media/LENS_CULINARIS_SIRE_6.9f93870f.jpg";